// Module
var code = `<predicate predicates="\$ctrl.predicates"
           ng-disabled="\$ctrl.ngDisabled"
           access-input="\$ctrl.inputDefinition"
           type="\$ctrl.type">

  <select ng-options="ar.value as ar.label for ar in \$ctrl.inputDefinitions"
          ng-model="\$ctrl.inputDefinition"
          ng-change="\$ctrl.inputDefinitionChanged()"
          ng-disabled="\$ctrl.ngDisabled"
          required>
  </select>

  <span ng-if="\$ctrl.type =='GREATER_THAN_OR_EQUAL_AMOUNT'">
    &gt;=
  </span>
  <span ng-if="\$ctrl.type =='GREATER_THAN_AMOUNT'">
    &gt;
  </span>
  <span ng-if="\$ctrl.type =='LESS_THAN_AMOUNT'">
    &lt;
  </span>
  <span ng-if="\$ctrl.type =='LESS_THAN_OR_EQUAL_AMOUNT'">
    &lt;=
  </span>

  <cash ng-model="\$ctrl.value"
        ng-disabled="\$ctrl.ngDisabled"
        ng-change="\$ctrl.valueChanged()"
        ng-required="true"></cash>
</predicate>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/security/role-write-access/predicates/amount-predicate.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;